export default __webpack_public_path__ + "static/media/SUNITA.cb374a5c.png";